import { useSelector, shallowEqual } from 'react-redux';

import { selectors as meterpointValidationSelectors } from 'state/meterpoint-validation/meterpoint-validation-slice';
import { GuideHelpText } from 'components/direct-sales/meterpoint-validation/components/GuideHelpText';

const {
  selectMeterAddresses,
  selectUserMeterpoints,
  selectValidationRequired,
  selectAPIErrors,
  selectValidationErrors,
  selectIsLoading
} = meterpointValidationSelectors;

export const useMeterpointValidation = () => {
  const { MPAN, MPRN } = useSelector(selectUserMeterpoints, shallowEqual);
  const addresses = useSelector(selectMeterAddresses, shallowEqual);
  const {
    electricity: electricityValidation,
    gas: gasValidation
  } = useSelector(selectValidationRequired, shallowEqual);

  const apiErrors = useSelector(selectAPIErrors, shallowEqual);
  const validationErrors = useSelector(selectValidationErrors, shallowEqual);
  const isLoading = useSelector(selectIsLoading, shallowEqual);
  const errors = [
    ...apiErrors,
    ...validationErrors.map((error) => {
      return {
        ...error,
        message: <GuideHelpText />
      };
    })
  ];
  const hasElecAddress = !!addresses.electricity;
  const hasGasAddress = !!addresses.gas;
  const hasMissingAddress =
    (electricityValidation && !hasElecAddress) ||
    (gasValidation && !hasGasAddress);

  return {
    addresses,
    gasValidation,
    electricityValidation,
    errors,
    isLoading,
    MPAN,
    MPRN,
    hasElecAddress,
    hasGasAddress,
    hasMissingAddress,
    elecAddress: addresses.electricity,
    gasAddress: addresses.gas
  };
};
